<div class="dropdown dropdown-end cursor-pointer">
    <!-- Trigger -->
    <div tabindex="0" role="button" class="max-w-full relative rounded bg-base-100/5 backdrop-blur-sm border-base-100/15 p-2 border 
           hover:bg-base-100/10 transition
            flex items-center gap-2
           " [class.active-accent]="notReadNotificationsCount() > 0">
        <span class="material-symbols-outlined text-sm">
            notifications
        </span>

        <!-- <span class="text-sm font-medium">
            Notifications
        </span> -->

        <!-- Count badge -->
        @if (notReadNotificationsCount()) {
        <span class="absolute -top-1 -right-1
               badge badge-sm badge-accent">
            {{ notReadNotificationsCount() }}
        </span>
        }
    </div>

    <!-- Dropdown -->
    <div tabindex="0" class="rounded menu dropdown-content mt-2 z-1 p-3 w-96 
           bg-base-100/5 backdrop-blur-2xl 
           shadow-xl
           border border-base-100/15 gap-2" [class.higlight-accent]="notReadNotificationsCount() > 0">
        <h3>Notifications</h3>
        <!-- Empty state -->
        @if (!activeNotifications().length) {
        <li class="px-4 py-6 text-center text-sm opacity-60">
            No notifications right now 🎉
        </li>
        }
        <!-- Notifications -->
        <ul class="max-h-96 overflow-y-auto max-w-full grid gap-2 ">
            @for (n of activeNotifications(); track n.id) {
            <li class="max-w-full rounded-lg border border-base-100/15 backdrop-blur-md"
                [class.not-read]="!notificationRead(n)">
                <button class="flex gap-3 px-4 py-3 max-w-full text-left
             hover:bg-base-100/10 transition" (click)="onClick(n)">

                    <!-- Content -->
                    <div [title]="n.title" class="flex-1 min-w-0" [class.opacity-80]="notificationRead(n)">
                        <p class="text-sm font-medium truncate">
                            {{ n.title }}
                        </p>

                        <p class="text-xs opacity-70 line-clamp-2">
                            {{ n.summary }}
                        </p>

                        <p class="text-[11px] opacity-40 mt-1">
                            {{ n.releaseDate || n.availableFrom | date:'MMM d' }}
                        </p>
                    </div>
                </button>
            </li>
            }
        </ul>

        <!-- Footer -->
        <li class="w-full float-right">
            <button (click)="router.navigate(['/notifications'])" class="text-left w-fit text-sm hover:text-base-content/80 transition">
                View all notifications →
            </button>
        </li>
    </div>
</div>